/**
 * Created by Mohdan on 01.10.2026
 */

const OnePlusOneOfferWindow = Prefab.createWindow("oneplusone_offer", "oneplusoneofferwindow_prefab_json");
